import { useEffect } from 'react'

/**
 * Naver OAuth 콜백 페이지 (팝업 내에서 실행)
 * URL 해시에서 access_token을 추출하여 부모 윈도우로 전달
 */
export function NaverCallbackPage() {
  useEffect(() => {
    const hash = window.location.hash
    if (hash) {
      // #access_token=xxx&state=yyy&token_type=bearer&expires_in=3600
      const params = new URLSearchParams(hash.substring(1))
      const token = params.get('access_token')

      if (token && window.opener) {
        window.opener.postMessage({ type: 'NAVER_LOGIN', token }, window.location.origin)
        window.close()
        return
      }
    }

    // 토큰 없거나 opener 없으면 3초 후 닫기
    setTimeout(() => window.close(), 3000)
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-500">로그인 처리 중...</p>
    </div>
  )
}
